import React from 'react';
import './OfferingsSection.css';

const OfferingsSection = () => {
  const offerings = [
    {
      id: 'Balvatika',
      label: 'Balvatika',
      grades: 'Balvatika-1 to Balvatika-3',
      description:
        'A warm, child-friendly beginning with curated activities that develop language, early numeracy, motor skills and social habits through play.'
    },
    {
      id: 'primary',
      label: 'Primary School',
      grades: 'Grade 1 to 5',
      description:
        'Strong foundation in English, Mathematics, Environmental Studies and languages with activity-based learning that keeps curiosity alive.'
    },
    {
      id: 'Higher primary',
      label: 'Higher primary',
      grades: 'Grade 6 to 8',
      description:
        'Concept clarity in all core subjects, regular assessments and projects that prepare learners for higher academic expectations.'
    },
    {
      id: 'secondary',
      label: 'Secondary School',
      grades: 'Grade 9 to 10',
      description:
        'Focused academic guidance, disciplined study habits and mentoring to help students perform confidently in board examinations and beyond.'
    }
  ];

  return (
    <section className="offerings-section">
      <div className="container">
        <h2 className="section-title">CLASSES FROM BALVATIKA   TO GRADE 10</h2>
        <p className="offerings-intro">
          Pragati Vidyalaya offers a complete school journey from Balvatika to Grade 10.
          Each stage is planned to meet the needs of children at that age so that they grow
          happily and confidently, step by step.
        </p>
        <div className="offerings-grid">
          {offerings.map((offering) => (
            <div key={offering.id} className="offering-card">
              <div className="offering-header">
                <h3 className="offering-label">{offering.label}</h3>
                <span className="offering-grades">{offering.grades}</span>
              </div>
              <p className="offering-description">{offering.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfferingsSection;
